export const buildComplete = 'complete';

export const buildInProgress = 'in_progress';

export const TUNNEL_TYPE_SSL = 'ssl';
export const TUNNEL_TYPE_IPSEC = 'ipsec';

export const TUNNEL_LABEL_SSL = 'SSL';
export const TUNNEL_LABEL_IPSEC = 'IPSEC';

export const OS_WINDOWS = 'windows';
export const OS_ANDROID = 'android';
export const OS_IOS = 'ios';
export const OS_MAC = 'mac';
export const OS_LINUX = 'linux';
export const OS_OTHER = 'other';

export const ARGUS_MODE_ANTIVIRUS = 'antivirus';
export const ARGUS_MODE_PROXY = 'proxy';
